import Marquee from "react-fast-marquee";

const items = ["Design sur mesure", "Performance", "Expertise SEO", "Mobile first", "Aperçu gratuit", "Expérience premium", "Tous domaines"];

export const EditorialMarquee = () => (
  <div className="relative py-7 border-y border-white/[0.05] overflow-hidden" data-testid="marquee-section">
    <Marquee speed={20} gradient={false} autoFill>
      {items.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-mono-label text-[11px] md:text-xs tracking-[0.4em] uppercase text-white/35 px-10">
            {item}
          </span>
          <span className="w-1 h-1 rounded-full bg-cyan-400/40" />
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
